module.exports = __webpack_public_path__ + "assets/bd851855c3e4ffa1faafca0752d22439.mp4";